import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the FilterIncomesView.
 * @extends JetView
 */
export default class FilterIncomesView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Left section with ID input
        const left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'Id',
                    type: 'number',
                    label: _("<span class='icon-drivers-license-o'></span>ID"), // ID label
                    labelPosition: 'top',
                    placeholder: _('ID'), // Placeholder for ID input
                },
            ],
        };

        // Center left section with date picker
        const center_left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'CreatedLocalDate',
                    id: 'Datepicker', // ID for date picker
                    css: 'reportrange',
                    readonly: true, // Read-only date picker
                    label: _("<span class='webix_icon icon-calendar'></span> Fecha de Creación"), // Creation date label
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder for date picker
                },
            ],
        };

        // Center right and right sections (currently empty)
        const center_right = {
            margin: 5,
            minWidth: 200,
            rows: [],
        };
        const right = {
            margin: 5,
            minWidth: 200,
            rows: [],
        };

        // Left section with income type combo
        const left2 = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'combo',
                    name: 'TypeIncomes',
                    id: 'TypeIncomesFilter', // ID for income type filter
                    label: _('Tipo de Egreso'), // Income type label
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder for income type combo
                },
            ],
        };

        // Center left section with concepts combo
        const center_left2 = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'combo',
                    name: 'Concepts',
                    id: 'ConceptsFilter', // ID for concepts filter
                    label: _('Concepto'), // Concept label
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder for concepts combo
                },
            ],
        };

        // Center right section with document ID input
        const center_right2 = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'DocumentID',
                    type: 'number',
                    label: _('Documento ID'), // Document ID label
                    labelPosition: 'top',
                    placeholder: _('Documento ID'), // Placeholder for document ID input
                },
            ],
        };

        // Right section (currently empty)
        const right2 = {
            margin: 5,
            minWidth: 200,
            rows: [],
        };

        // Upper section layout
        const upper_section = {
            id: 'a1',
            rows: [
                {
                    responsive: 'a1',
                    margin: 10,
                    cols: [left, center_left, center_right, right],
                },
            ],
        };

        // Second upper section layout
        const upper_section2 = {
            id: 'a1',
            rows: [
                {
                    responsive: 'a1',
                    margin: 10,
                    cols: [left2, center_left2, center_right2, right2],
                },
            ],
        };

        // Accordion section for advanced filters
        const accordion_section = {
            id: 'b5',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: false,
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros Avanzados'), // Advanced filters header
                            body: {
                                padding: 10,
                                rows: [upper_section2],
                            },
                        },
                    ],
                },
            ],
        };

        // Button section with actions
        const buttons = {
            margin: 5,
            cols: [
                {},
                {
                    view: 'button',
                    value: _('Añadir Ingreso'), // Add Income button
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        this.app.callEvent('AddIncome:button', [{}]); // Event for adding income
                    },
                },
                {
                    view: 'button',
                    value: _('Limpiar'), // Clear button
                    autowidth: true,
                    click: () => {
                        this.getRoot().clear(); // Clear form inputs
                    },
                },
                {
                    view: 'button',
                    value: _('Consultar'), // Consult button
                    hotkey: 'enter', // Enter key to trigger
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        this.app.callEvent('incomes:filter', [filterdata]); // Event for filtering incomes
                    },
                },
            ],
        };

        // Return the complete form configuration
        return {
            view: 'form',
            rows: [upper_section, accordion_section, buttons],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and loads data.
     */
    init() {
        // Load income types from API
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json',
            })
            .post(
                devConfig.geturlApi() + 'Accounting/GetTypesCenterPositionSelect',
                '{"Type":3}', // Request payload
                {
                    error: function (text, data, XmlHttpRequest) {
                        webix.message('Error! '); // Error message on failure
                    },
                    success: function (text, data, XmlHttpRequest) {
                        var resp = JSON.parse(text); // Parse response
                        $$('TypeIncomesFilter').define('options', resp.Data); // Set options for income type filter
                        $$('TypeIncomesFilter').refresh(); // Refresh filter
                    },
                },
            );

        // Load concepts from API
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json',
            })
            .post(devConfig.geturlApi() + 'Accounting/GetConceptsSelect', '', {
                error: function (text, data, XmlHttpRequest) {
                    webix.message('Error! '); // Error message on failure
                },
                success: function (text, data, XmlHttpRequest) {
                    var resp = JSON.parse(text); // Parse response
                    $$('ConceptsFilter').define('options', resp.Data); // Set options for concepts filter
                    $$('ConceptsFilter').refresh(); // Refresh filter
                },
            });
    }
}

// FILE DOCUMENTED
